import { callApi } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import ErrorMessage from '@/components/common/ErrorMessage';
import FormButtons from '@/components/common/Form/FormButtons';
import CardLayout from '@/components/Layout/CardLayout';
import FieldLayout from '@/components/Layout/FieldLayout';
import Layout from '@/components/Layout/Layout';
import BackButton from '@/components/ui/BackButton';
import Label from '@/components/ui/Label';
import PrimaryInput from '@/components/ui/PrimaryInput';
import ToggleInput from '@/components/ui/ToggleInput';
import { IDeleteResponse } from '@/interfaces/common.model';
import { showToastNotification } from '@/utility/helper';
import { errorTypes } from '@/utility/validation';
import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
interface IAddSalaryHead {
  name: string;
  type: string;
  wantToShowInOfferLetter: string;
  fromEmployeer: string;
  isActive?: boolean;
}
export const AddSalaryHead = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<IAddSalaryHead>();
  const onSubmit: SubmitHandler<IAddSalaryHead> = async (data) => {
    setIsLoading(true);
    const response: IDeleteResponse = await callApi(
      location?.state?.data
        ? API_URL +
            API_ENDPOINT.updateSalaryHead +
            `?salaryHeadId=${location?.state?.data?.id}`
        : API_URL + API_ENDPOINT.createSalaryHead,
      {
        method: 'POST',
        data: data,
      },
    );
    setIsLoading(false);
    if (response?.status) {
      showToastNotification('success', response?.message);
      navigate(-1);
      reset();
    } else {
      showToastNotification('danger', response?.message);
    }
  };
  useEffect(() => {
    if (location?.state?.data) {
      const data = location?.state?.data;
      reset({
        name: data?.name,
        type: data?.type,
        wantToShowInOfferLetter: data?.wantToShowInOfferLetter,
        fromEmployeer: data?.fromEmployeer,
      });
    }
  }, [location?.state?.data]);
  return (
    <Layout>
      <div className="content container-fluid">
        <BackButton label="Salary Head" isEdit={location?.state?.data} />
        <form onSubmit={handleSubmit(onSubmit)}>
          <CardLayout>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-BasicDetails"
                role="tabpanel"
                aria-labelledby="pills-BasicDetails-tab"
                tabIndex={0}
              >
                <div className="row">
                  <FieldLayout fieldStyle="col-12 col-lg-6">
                    <PrimaryInput
                      label=" Name"
                      required={true}
                      errors={errors?.name?.message}
                      className={` ${errors.name ? 'is-invalid' : ''}`}
                      placeholder="Head Name"
                      {...register('name', {
                        ...errorTypes.required('Name'),
                        ...errorTypes.name,
                      })}
                    />
                  </FieldLayout>
                  <FieldLayout fieldStyle="col-12 col-lg-6">
                    <Label required={true} id={'type'}>
                      Type
                    </Label>
                    <select
                      className={`form-control form-select ${
                        errors.type ? 'is-invalid' : ''
                      }`}
                      aria-label="Default select example"
                      {...register('type', {
                        required: 'This field is required',
                      })}
                    >
                      <option value="" className="text-muted">
                        Select Head type
                      </option>
                      <option value={'earning'}>Earning</option>
                      <option value={'deduction'}>Deduction</option>
                    </select>
                    <ErrorMessage message={errors?.type?.message} />
                  </FieldLayout>
                  <FieldLayout fieldStyle="col-12 col-lg-6">
                    <ToggleInput
                      label="Show in Offer Letter"
                      {...register('wantToShowInOfferLetter', {
                        // required: 'This field is required',
                      })}
                      id="offerLetter"
                      className={`form-check-input rounded-4 ${
                        errors.isActive ? 'is-invalid' : ''
                      }`}
                    />
                    {/* <Label
                      labelClassname="form-label d-block "
                      required={true}
                      id={'offerLetterYes'}
                    >
                      Show in Offer Letter
                    </Label>
                    <div className="form-check form-check-inline mt-3">
                      <input
                        type="radio"
                        style={{ cursor: 'pointer' }}
                        id="offerLetterYes"
                        value="true"
                        {...register('wantToShowInOfferLetter', {
                          required: 'This field is required',
                        })}
                        className={`form-check-input ${errors.wantToShowInOfferLetter ? 'is-invalid' : ''
                          }`}
                      />
                      <label
                        htmlFor="offerLetterYes"
                        style={{ cursor: 'pointer' }}
                        className="form-check-label"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        style={{ cursor: 'pointer' }}
                        id="offerLetterNo"
                        value="false"
                        {...register('wantToShowInOfferLetter', {
                          required: 'This field is required',
                        })}
                        className={`form-check-input ${errors.wantToShowInOfferLetter ? 'is-invalid' : ''
                          }`}
                      />
                      <label
                        htmlFor="offerLetterNo"
                        style={{ cursor: 'pointer' }}
                        className="form-check-label"
                      >
                        No
                      </label>
                    </div> */}
                    <ErrorMessage
                      message={errors?.wantToShowInOfferLetter?.message}
                    />
                  </FieldLayout>
                  <FieldLayout fieldStyle="col-12 col-lg-6">
                    {/* <Label
                      labelClassname="form-label d-block "
                      required={true}
                      id="fromEmployeerYes"
                    >
                      From Employeer
                    </Label> */}
                    <ToggleInput
                      label="From Employeer"
                      id="fromEmployers"
                      {...register('fromEmployeer', {
                        // required: 'This field is required',
                      })}
                      className={`form-check-input rounded-4 ${
                        errors.isActive ? 'is-invalid' : ''
                      }`}
                    />
                    {/* <div className="form-check form-check-inline mt-3">
                      <input
                        type="radio"
                        style={{ cursor: 'pointer' }}
                        id="fromEmployeerYes"
                        value="true"
                        {...register('fromEmployeer', {
                          required: 'This field is required',
                        })}
                        className={`form-check-input ${errors.fromEmployeer ? 'is-invalid' : ''
                          }`}
                      />
                      <label
                        htmlFor="fromEmployeerYes"
                        style={{ cursor: 'pointer' }}
                        className="form-check-label"
                      >
                        Yes
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        style={{ cursor: 'pointer' }}
                        id="fromEmployeerNo"
                        value="false"
                        {...register('fromEmployeer', {
                          required: 'This field is required',
                        })}
                        className={`form-check-input ${errors.fromEmployeer ? 'is-invalid' : ''
                          }`}
                      />
                      <label
                        htmlFor="fromEmployeerNo"
                        style={{ cursor: 'pointer' }}
                        className="form-check-label"
                      >
                        No
                      </label>
                    </div> */}
                    <ErrorMessage message={errors?.fromEmployeer?.message} />
                  </FieldLayout>
                </div>
              </div>
              <FormButtons buttonStyle="gap-4" isLoading={isLoading}>
                {location?.state?.data ? 'Update' : 'Create'}
              </FormButtons>
            </div>
          </CardLayout>
        </form>
      </div>
    </Layout>
  );
};
export default AddSalaryHead;
